module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daylightrain@2-51776dab16c29db813792fcbc24d6122.png";